<template>
  <div class="product-form-group">
    <div class="d-flex align-center flex-wrap">
      <div v-if="required" class="mark required">必須</div>
      <div v-else class="mark">任意</div>
      <div class="label flex-grow-1">
        {{ label }}
        <span class="note">{{ note }}</span>
      </div>
      <div v-if="$slots.default" :class="fullWidth ? 'full' : 'right'">
        <slot />
      </div>
    </div>
    <div v-if="$slots.after" class="after">
      <slot name="after" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ""
    },
    note: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
  }
};
</script>

<style lang="scss" scoped>
.product-form-group {
  padding: 22px 12px;
  background-color: #fff;
  margin-bottom: 8px;
}

.mark {
  padding: 7px 9px;
  border-radius: 3px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  background-color: #2c7eb1;

  &.required {
    background-color: #c85c45;
  }
}

.label {
  font-size: 20px;
  font-weight: bold;
  margin: 0 15px;
}

.note {
  margin-left: 20px;
  font-weight: bold;
  font-size: 16px;
  color: #c85c45;
  vertical-align: middle;
}

.right {
  @media screen and (max-width: 960px) {
    width: 100%;
    margin-top: 20px;
  }
}
.full {

    width: 100%;
    margin-top: 20px;
}

.after {
  margin-top: 20px;
}
</style>
